import React from "react";
import PropTypes from "prop-types";
import styles from "./EagleList.module.css";
import { EagleItem } from "../EagleItem/EagleItem";
import { EagleHeader } from "../EagleHeader/EagleHeader";

export function EagleList({
  list = [],
  header,
  pvOnly = false,
  headerDividerClassName,
}) {
  return (
    <div className={styles.container}>
      <EagleHeader
        header={header.header}
        color={header.color}
        icon={header.icon}
        onClick={header.onClick}
        count={header.count}
        rightLabel={header.rightLabel}
        chip={header.chip}
      />
      {headerDividerClassName ? (
        <div className={headerDividerClassName} />
      ) : null}
      {list.map((eagleItem, index) => (
        <EagleItem
          key={index}
          name={eagleItem.name}
          avatar={eagleItem.avatar}
          onClick={eagleItem.onClick}
          totalBonus={eagleItem.totalBonus}
          totalPremier={eagleItem.totalPremier}
          totalMajorFunctions={eagleItem.totalMajorFunctions}
          pvOnly={pvOnly}
          sponsorName={eagleItem.sponsorName}
        />
      ))}
    </div>
  );
}

EagleList.propTypes = {
  list: PropTypes.array.isRequired,
  header: PropTypes.object.isRequired,
  pvOnly: PropTypes.bool,
  headerDividerClassName: PropTypes.string,
};
